import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DropZone from 'modules/core/components/DropZone'
import Loading from 'modules/core/components/Loading'
import { Return } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

import { acceptedContentTypesByTasks } from '../../TaskForm'
import FileComponent, { FileOptions } from '../Attachments/File'

interface Props {
  title?: string
  description?: string
  employee?: Employee
  fileSubtitle?: string
  loading?: boolean
  canEditEmployeeDocuments?: boolean
  disabled?: boolean
  fileOptions: FileOptions[]
  folderId?: number
  onAddFiles: (files: File[]) => Promise<Return<void>>
}

const UploadDocuments = ({
  title,
  description,
  employee,
  fileSubtitle,
  loading,
  canEditEmployeeDocuments,
  disabled,
  onAddFiles,
  fileOptions,
}: Props) => {
  if (loading) return <Loading />

  return (
    <Box gap="s16">
      {title && <Text.Header2>{title}</Text.Header2>}
      {description && <Text.Normal color="grey800">{description}</Text.Normal>}
      {!canEditEmployeeDocuments && (
        <Alert color="warning">
          <Box flexDirection="row" gap="s8">
            <Icon.Medium icon="alert-circle" color="grey800" />
            <Text.Normal color="grey1000" whiteSpace="breakSpaces">
              {employee
                ? i18n.t('tasks.types.upload_document.details.forbidden_message', {
                    employee: employeeUser(employee).fullName(),
                  })
                : i18n.t('tasks.types.upload_document.details.forbidden_message_no_employee')}
            </Text.Normal>
          </Box>
        </Alert>
      )}
      <Box gap="s2">
        {fileSubtitle && <Text.Normal weight="semibold">{fileSubtitle}</Text.Normal>}
        <Box background="white" borderRadius={{ all: 'abs006' }}>
          <DropZone
            subtitle={i18n.t('tasks.types.upload_document.types')}
            disabled={disabled || !canEditEmployeeDocuments}
            accept={acceptedContentTypesByTasks()}
            onDrop={onAddFiles}
          />
        </Box>
      </Box>
      <Box gap="s16">
        {fileOptions.map((file, index) => (
          <FileComponent showDeleteOnly key={index} fileOptions={file} />
        ))}
      </Box>
    </Box>
  )
}

export const UploadDocumentsComponent = observer(UploadDocuments)
